<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import api from "../src/common/js/api";
export default {
  components: {},
  data() {
    return {
    };
  },
  created() {},
  mounted() {
    this.getWxConfig();
  },
  watch: {},
  methods: {
    getWxConfig() {
      // 微信签名要求 url 与地址栏完全一致（不含 # 及其后部分），必须原样传参，不能 encodeURIComponent
      let urlNow = window.location.href.split("#")[0];

      this.$post(api.wxConfig, { url: urlNow }).then((res) => {
        // 兼容接口返回 {data:{...}} 与直接返回字段两种结构，避免 appId 等取不到导致签名失败
        let data = res.data || res;
        if (!data.appId || !data.signature || !data.timestamp || !data.nonceStr) {
          this.$toast("微信配置接口返回异常：" + JSON.stringify(res));
          return;
        }
        wx.config({
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
         debug: false,
          // 必填，公众号的唯一标识
          appId: data.appId,
          // 必填，生成签名的时间戳
          timestamp: data.timestamp,
          // 必填，生成签名的随机串
          nonceStr: data.nonceStr,
          // 必填，签名
          signature: data.signature,
          // 必填，需要使用的JS接口列表，所有JS接口列表
          jsApiList: ["scanQRCode"],
        });
        // 配置失败时给出提示，带上 appId 和 url，方便核对公众号与后端签名用的地址
        wx.error((err) => {
          this.$toast(
            "微信配置失败：" +
              (err.errMsg || JSON.stringify(err)) +
              ",urlNow:" +
              urlNow +
              ",（appId:" +
              data.appId +
              "，url:" +
              urlNow +
              "）"
          );
        });
      });

      // this.$post(api.wxConfig, { url: urlNow }).then(() => {
      //   wx.config({
      //     // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //    debug: true,
      //     // 必填，公众号的唯一标识
      //     appId: "wx3fbf6f30ae7bb620",
      //     // 必填，生成签名的时间戳
      //     timestamp: "1626077957",
      //     // 必填，生成签名的随机串
      //     nonceStr: "a76376d2a55543ac",
      //     // 必填，签名
      //     signature: "6f2ce0a9ed070862ea8bb29aa4834a1483d4e84c",
      //     // 必填，需要使用的JS接口列表，所有JS接口列表
      //     jsApiList: ["scanQRCode"],
      //   });
      // });

    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
